// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-menu {
  padding: 6px;
  font-size: 1.2em;
  font-weight: bold;
  cursor: pointer;
}
.user-menu .ant-avatar {
  border: 1px solid #137CBD;
  transition: border 0.3s;
  margin-right: 10px;
}
.user-menu .username {
  color: #137CBD;
  transition: color 0.3s;
}
.user-menu .username i {
  font-size: 0.6em;
}
.user-menu:hover .username {
  color: #0a3f60;
}
.user-menu:hover .ant-avatar {
  border: 1px solid #0a3f60;
}
ul.ant-dropdown-menu.user-chip-menu {
  border: 2px solid #137CBD;
  background-color: #fafafb;
  border-radius: 0 0 8px 8px;
  border-top: 2px solid #fafafb;
}
ul.ant-dropdown-menu.user-chip-menu i {
  padding-right: 10px;
}
ul.ant-dropdown-menu.user-chip-menu div.user-name {
  padding: 13px;
  cursor: default;
}
ul.ant-dropdown-menu.user-chip-menu div.user-name span {
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/Component/Menu/User/User.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AACF;AALA;EAOI,yBAAA;EACA,uBAAA;EACA,kBAAA;AACJ;AAVA;EAaI,cAAA;EACA,sBAAA;AAAJ;AAdA;EAiBM,gBAAA;AAAN;AAIE;EACE,cAAA;AAFJ;AAKE;EACE,yBAAA;AAHJ;AAOA;EACE,yBAAA;EACA,yBAAA;EACA,0BAAA;EACA,6BAAA;AALF;AACA;EAOI,mBAAA;AALJ;AAFA;EAWI,aAAA;EACA,eAAA;AANJ;AANA;EAeM,iBAAA;AANN","sourcesContent":[".user-menu {\n  padding: 6px;\n  font-size: 1.2em;\n  font-weight: bold;\n  cursor: pointer;\n\n  .ant-avatar {\n    border: 1px solid @primary-color;\n    transition: border 0.3s;\n    margin-right: 10px;\n  }\n\n  .username {\n    color: @primary-color;\n    transition: color 0.3s;\n\n    i {\n      font-size: 0.6em;\n    }\n  }\n\n  &:hover .username {\n    color: darken(@primary-color, 20%);\n  }\n\n  &:hover .ant-avatar {\n    border: 1px solid darken(@primary-color, 20%);\n  }\n}\n\nul.ant-dropdown-menu.user-chip-menu {\n  border: 2px solid @primary-color;\n  background-color: #fafafb;\n  border-radius: 0 0 8px 8px;\n  border-top: 2px solid #fafafb;\n\n  i {\n    padding-right: 10px;\n  }\n\n  div.user-name {\n    padding: 13px;\n    cursor: default;\n\n    span {\n      font-weight: bold;\n    }\n  }\n\n}\n\n@drawer-width: 600px;@primary-color: #137CBD;@info-color: #137CBD;@success-color: #0F9960;@warning-color: #D9822B;@error-color: #DB3737;@link-color: #137CBD;@font-size-base: 14px;@heading-color: rgba(0, 0, 0, 0.85);@text-color: rgba(0, 0, 0, 0.65);@text-color-secondary: rgba(0, 0, 0, .45);@disabled-color: rgba(0, 0, 0, .25);@border-radius-base: 0px;@border-color-base: #d9d9d9;@box-shadow-base: 0 2px 8px rgba(0, 0, 0, 0.15);"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
